import { useSelector } from "react-redux";
import SidebarLayout from "../../components/Sidebar/SidebarLayout";
import UserPage from "./users/UserPage";
import BillingPage from "./billing/BillingPage";
import OrganizationPage from "./organization/OrganizationPage";
import { isTenantManager } from "../../utils/permissionUtils";

export default function SettingsPage() {
    // Get the current user from Redux state
    const user = useSelector((state) => state.auth.user);

    // Define all possible pages
    const allPages = [
        {
            name: "Organization",
            component: <OrganizationPage />,
            path: "company",
            icon: "bi bi-building",
        },
        {
            name: "Users",
            component: <UserPage />,
            path: "users",
            icon: "bi bi-people",
        },
        {
            name: "Billing",
            component: <BillingPage />,
            path: "billing",
            icon: "bi bi-receipt",
        },
        // {
        //     name: "Payments",
        //     component: <PaymentsPage />,
        //     path: "payments",
        //     icon: "bi bi-coin",
        // },
    ];

    // Filter pages based on user role
    const pageData = isTenantManager(user)
        ? allPages.filter((page) => page.path === "users")
        : allPages;

    return <SidebarLayout pageData={pageData} defaultPage="users" />;
}
